import selfInstantiateOnLoad from "../utilities/instantiateUtility";
const jWindow = window;
class FireplaceDetails {
    constructor() {
        this._handleTabs();
        this._setupSlick();
    }
    _handleTabs() {
        const tabs = document.querySelectorAll(FireplaceDetails.TabSelector);
        for (let i = 0; i < tabs.length; i++) {
            const tab = tabs[i];
            tab.addEventListener("click", () => {
                FireplaceDetails.deactivateAllTabs(tabs);
                FireplaceDetails.activateTab(tab);
            });
        }
    }
    _setupSlick() {
        jWindow.jQuery("#rtl-slider-product").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: "#rtl-slider-nav",
        });
        jWindow.jQuery("#rtl-slider-nav").slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            vertical: true,
            asNavFor: "#rtl-slider-product",
            centerMode: false,
            focusOnSelect: true,
            prevArrow: ".thumb-prev",
            nextArrow: ".thumb-next",
        });
        jWindow.jQuery(".responsive").slick({
            dots: true,
            prevArrow: jWindow.jQuery(".prev"),
            nextArrow: jWindow.jQuery(".next"),
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true,
                    },
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }
    static activateTab(elem) {
        elem.classList.add("active");
    }
    static deactivateTab(elem) {
        elem.classList.remove("active");
    }
    static deactivateAllTabs(elems) {
        for (let i = 0; i < elems.length; i++) {
            FireplaceDetails.deactivateTab(elems[i]);
        }
    }
}
FireplaceDetails.TabSelector = "#product-description-tab-panels [data-toggle=tab]";
selfInstantiateOnLoad(FireplaceDetails);
